import { render, staticRenderFns } from "./StepBase.vue?vue&type=template&id=8f46f3a6"
import script from "./StepBase.vue?vue&type=script&lang=ts"
export * from "./StepBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports